export default __webpack_public_path__ + "d8e4869.png";